import React, { useCallback, useEffect, useState } from "react";
import { CustomCellRendererProps } from "@ag-grid-community/react";
import { RowEvent } from "@ag-grid-community/core";
import { Icon } from "./style.css";

const DayWiseCoverageMap: any = {
  NK: "No Kit Orders",
  FK: "Full Kit Orders",
  PK: "Partial Kit Orders",
};

const CustomGroupCellRenderer = (props: CustomCellRendererProps) => {
  const { node, value } = props;
  const [expanded, setExpanded] = useState(node.expanded);

  //if you want to have rows expanded initially
  useEffect(() => {
    const expandListener = (event: any) =>
      setExpanded(event.node.expanded);

    node.addEventListener("expandedChanged", expandListener);

    return () => {
      node.removeEventListener("expandedChanged", expandListener);
    };
  }, []);

  const onClick = useCallback(() => node.setExpanded(!node.expanded), [node]);

  return node.group ? (
    <button
      data-testid="collapsable"
      style={{
        fontSize: "12px",
        background: "transparent",
        fontWeight: "bold",
      }}
      onClick={onClick}
    >
      {DayWiseCoverageMap[value] ? DayWiseCoverageMap[value] : value}&nbsp;(
      {props.node.allChildrenCount})&nbsp;&nbsp;
      <img
        className={Icon}
        src={
          expanded
            ? "/assets/img/mto/dayWiseCoverage/arrow_down.svg"
            : "/assets/img/mto/dayWiseCoverage/arrow_right.svg"
        }
        alt=""
      />
    </button>
  ) : (
    <button
      data-testid="collapsable"
      style={{
        width: "100%",
        background: "transparent",
        textAlign: "right",
        height: "100%",
      }}
      onClick={onClick}
    >
      <img
        className={Icon}
        height={20}
        width={20}
        src={
          expanded
            ? "/assets/img/mto/dayWiseCoverage/collapse.svg"
            : "/assets/img/mto/dayWiseCoverage/expand.svg"
        }
        alt=""
      />
    </button>
  );
};

export default CustomGroupCellRenderer;
